import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { Avatar, IconButton, Menu, MenuItem } from "@mui/material";
import SignOutButton from "./SignOutButton";
import { useAccount } from "@azure/msal-react";

const ResponsiveAppBar: React.FC = () => {
  const accountInfo = useAccount();
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(
    null
  );

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <AppBar position="static" className="fixed">
      <Toolbar
        sx={{
          justifyContent: "space-between",
        }}
      >
        <div className="flex items-center">
          <Box
            component="div"
            sx={{
              display: { xs: "none", md: "flex" },
              my: 1,
              mr: 3,
              height: 30,
            }}
          >
            <img src="logoJC.svg" alt="" />
          </Box>
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: "none", md: "flex" },
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
              // flexGrow: 1,
            }}
          >
            John's Cockpit
          </Typography>
        </div>

        <Box
          component="div"
          sx={{ display: { xs: "flex", md: "none" }, my: 1, mr: 3, height: 30 }}
        >
          <img src="logoJC.svg" alt="" />
        </Box>
        <Typography
          variant="h5"
          noWrap
          component="a"
          href=""
          sx={{
            mr: 2,
            display: { xs: "flex", md: "none" },
            flexGrow: 1,
            fontWeight: 700,
            letterSpacing: ".3rem",
            color: "inherit",
            textDecoration: "none",
          }}
        >
          John's Cockpit
        </Typography>

        <Box sx={{ flexGrow: 0 }}>
          <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
            <Avatar
              alt={accountInfo?.username}
              src="/static/images/avatar/2.jpg"
            />
          </IconButton>
          <Menu
            sx={{ mt: "45px" }}
            id="menu-appbar"
            anchorEl={anchorElUser}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}
          >
            <MenuItem onClick={handleCloseUserMenu}>
              <SignOutButton>
                <Typography textAlign="center">Logout</Typography>
              </SignOutButton>
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};
export default ResponsiveAppBar;
